import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { useI18n } from '../../../../i18n';

const AddCardLink = ({ onClick }) => {
	const { t } = useI18n();
	return (
	<button type="button" className="board-add-control" onClick={onClick}>
		<FaPlus /> {t('board.addCard')}
	</button>
	);
};

export default AddCardLink;
